import { useEffect, useState } from "react";
import { TextInput } from "../common/index.js";

const TextFilter = ({ changeFilter, item, refresh }) => {
  const [value, setValue] = useState("");
  useEffect(() => {
    if (refresh > 0) {
        setValue("")
    }
  }, [refresh]);
  return (
    <>
      {" "}
      <TextInput
        label={item.title}
        currentValue={value}
 
        change={(e) => {
          setValue(e);
          changeFilter({
            name: item.name,
            value: e,
            type: "lk",
          });
        }}
      />
    </>
  );
};

export default TextFilter;
